import { useMemo as e } from "react";
//#region src/useStructMemo.ts
function t(t) {
	return e(() => ({ ...t }), Object.values(t));
}
//#endregion
export { t as useStructMemo };
